import * as React from 'react';
import { get } from 'lodash';
import { LazyImage } from 'src/components/common/modules/lazy/lazy-image';
import { checkValue, onImageLoadWithoutCache } from 'src/components/common/helper';
import { SpotlightImageProps } from 'src/components/spotlight/module-util';
import { FigureComponent } from 'src/components/common/ui';
import Layout from 'src/components/common/theme/Layout';
import { css } from 'styled-components';
import { setCustomizedStyles, mediaQueries, spacingSeter } from 'src/components/common/theme/component-styles';
import { pageWidthStyles } from 'src/customModulesStyles';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';

export default class SpotlightImage extends React.PureComponent<SpotlightImageProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShow: 'none',
      loadedClass: '',
    };
  }

  public isCopyrights = (e: any) => {
    this.setState({ isShow: this.state.isShow === 'block' ? 'none' : 'block' });
  };

  public updateLoaded = (isLoaded) => {
    if (isLoaded) {
      this.setState({ loadedClass: 'image-loaded' });
    } else {
      this.setState({ loadedClass: '' });
    }
  };

  public setRectangeColorBarBottomPosition = () => {
    const imageCaptionElement = document.querySelector(`#${this.props?.id} .image-caption`);
    const blr = document.querySelector(`#${this.props?.id} .image-module-bottom-left-color-bar`) as HTMLElement;
    const brr = document.querySelector(`#${this.props?.id} .image-module-bottom-right-color-bar`) as HTMLElement;
    const Xvalue = window?.innerWidth <= 575 ? 24 : window?.innerWidth <= 1024 ? 32 : 15;
    const imageCaptionHeight = imageCaptionElement ? imageCaptionElement?.clientHeight : 18;
    if (brr) {
      brr.style.transform = `translate(-${Xvalue}px , ${-30 - imageCaptionHeight}px)`;
    }
    if (blr) {
      blr.style.transform = `translate(${Xvalue}px , ${-30 - imageCaptionHeight}px)`;
    }
  };

  componentDidMount() {
    window.addEventListener('resize', this.setRectangeColorBarBottomPosition);
    window.addEventListener('load', this.setRectangeColorBarBottomPosition);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setRectangeColorBarBottomPosition);
    window.removeEventListener('load', this.setRectangeColorBarBottomPosition);
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getCamaraHTML = () => {
      if (checkValue(this.props.image.photographer)) {
        return (
          <div className="image-copyrights">
            <img
              className="camera-icon"
              src={onImageLoadWithoutCache("https://mesocp.azureedge.net/media/8d7fca0c8c2035d/icon-camera.svg")}
              alt=""
              onClick={this.isCopyrights}
            />
            <span style={{ display: this.state.isShow }}>{this.props.image.photographer}</span>
          </div>
        );
      }
    };
     
    const isBorderColorBars =
      checkValue(this?.props?.image?.borderTopRightColor) ||
      checkValue(this?.props?.image?.borderTopLeftColor) ||
      checkValue(this?.props?.image?.borderBottomLeftColor) ||
      checkValue(this?.props?.image?.borderBottomRightColor);
    
    const moduleCss = () => {
      return `
              ${
                this.props?.image?.pageWidth?.toLowerCase() !== 'narrow body' &&
                this.props.image?.moduleWidth?.toLowerCase() === 'narrow'
                  ? `
                .spotlight-component-wrapper.image-background-container-wrapper {
                    max-width: 635px !important;
                    @media only screen and (min-width: ${mediaQueries.mobile}) {
                      ${spacingSeter('padding-top', this.props?.image?.topPadding)};
                      ${spacingSeter('padding-bottom', this.props?.image?.bottomPadding)};
                    }
                    @media only screen and (max-width: ${
                      mediaQueries.tabmedium
                    }) {                                                        
                      max-width: 100% !important;             
                    }
                  }
                `
                  : ''
              }
              ${setCustomizedStyles(
                this.props.image?.moduleName,
                this.props?.image?.pageWidth?.toLowerCase(),
                pageWidthStyles
              )}
              ${setCustomizedStyles(this.props.image?.moduleName, this.props.image?.articleStyle)};
              ${
                checkValue(this.props.image.backgroundRectangleBarColor)
                  ? `.background-color-bar {
                background-color: ${this.props.image?.backgroundRectangleBarColor} 
              }`
                  : ''
              }
              ${
                checkValue(this.props.image.backgroundColor)
                  ? `{
                background-color: ${this.props.image.backgroundColor}
              }`
                  : ''
              }
              ${checkValue(this?.props?.image?.borderTopLeftColor) ? `&.image-background-container-section .image-module-top-left-color-bar {background:${this?.props?.image?.borderTopLeftColor} !important;}` : ""} 
              ${checkValue(this?.props?.image?.borderTopRightColor) ? `&.image-background-container-section .image-module-top-right-color-bar {background:${this?.props?.image?.borderTopRightColor} !important;}` : ""} 
              ${checkValue(this?.props?.image?.borderBottomRightColor) ? `&.image-background-container-section .image-module-bottom-right-color-bar {background:${this?.props?.image?.borderBottomRightColor} !important;}` : ""} 
              ${checkValue(this?.props?.image?.borderBottomLeftColor) ? `&.image-background-container-section .image-module-bottom-left-color-bar {background:${this?.props?.image?.borderBottomLeftColor} !important;}` : ""} 
            `;
    };

    const getHTML = () => {
      if (checkValue(this.props.image.img)) {
        let filterDevice: string = this.props.device;

        if (this.props.isGallery !== undefined && this.props.isGallery) {
          filterDevice = 'gallery-sml';
          if (checkValue(this.props.imgClass)) {
            if (this.props.imgClass === 'medium') {
              filterDevice = 'gallery-med';
            } else if (this.props.imgClass === 'large') {
              filterDevice = 'gallery-lge';
            }
          }
        }
        const filteredData = this.props.image.img.filter((heroItem) => heroItem.name === filterDevice);

        if (filteredData[0] && filteredData[0] !== undefined && filteredData[0] !== null && filteredData[0] !== '') {
          const imgURL: string = filteredData[0].url;
          const isGradientActive = this.props.image.isgradientoff === 'False' || this.props.image.turnOffGradient;
          const imgCaption = this.props.image?.caption;
          return (
            <Layout
              className="image-background-container-section"
              css={css`
                ${moduleCss()}
              `}
              id={this.props?.id}
            >
              <div
                className={`${!checkValue(this.props.isGalleryTemplate) ? 'spotlight-component-wrapper' : ''}
                image-background-container-wrapper ${
                  checkValue(this.props.image?.backgroundRectangleBarColor) ? 'image-background-color-bar-wrapper' : ''
                }
                ${
                  checkValue(this.props.image?.exClass === 'add-spacing') && checkValue(imgCaption)
                    ? 'add-spacing-with-caption'
                    : ''
                }
                ${
                  checkValue(this.props.image?.exClass === 'add-spacing') && !checkValue(imgCaption)
                    ? 'add-spacing-without-caption'
                    : ''
                }
                ${checkValue(isBorderColorBars) ? 'image-module-corner-color-bar-wrapper' : ""}
                `}
              >
                {checkValue(this.props.image?.backgroundRectangleBarColor) ? (
                  <div className="background-color-bar fade-in" />
                ) : null}
                {checkValue(this?.props?.image?.borderTopRightColor)&& (<div className="image-module-top-right-color-bar fade-in" />)}
                {checkValue(this?.props?.image?.borderTopLeftColor)&& (<div className="image-module-top-left-color-bar fade-in" />)}
                {checkValue(this?.props?.image?.borderBottomRightColor)&& (<div className="image-module-bottom-right-color-bar fade-in" />)}
                {checkValue(this?.props?.image?.borderBottomLeftColor)&& (<div className="image-module-bottom-left-color-bar fade-in" />)}
                <div
                  className={`image-wrapper ${
                    checkValue(this.props.isScrollIntoView) ? 'image-loaded' : this.state.loadedClass
                  }  mt-0`}
                >
                  {checkValue(this.props.isScrollIntoView) ? (
                    <>
                      <FigureComponent
                        src={imgURL}
                        alt={get(this, 'props.image.imageAltText', 'Article Image')}
                        exClass={`img-ratio ${this.props.imgClass}`}
                        copyRightProps={{
                          copyrightCation: this.props?.image?.photographer,
                          iconSize: checkValue(this.props?.image?.copyrightIconSize)
                            ? this.props?.image?.copyrightIconSize
                            : 'lg',
                        }}
                        isGradientActive={isGradientActive}
                      />
                    </>
                  ) : (
                    <LazyImage
                      altPlaceholderText={get(this, 'props.image.imageAltText', 'Article Image')}
                      updateLoaded={this.updateLoaded}
                      isGallery={this.props.isGallery}
                      device={this.props.device}
                    >
                      <FigureComponent
                        src={imgURL}
                        alt={get(this, 'props.image.imageAltText', 'Article Image')}
                        exClass={`img-ratio ${this.props.imgClass}`}
                        copyRightProps={{
                          copyrightCation: this.props?.image?.photographer,
                          iconSize: checkValue(this.props?.image?.copyrightIconSize)
                            ? this.props?.image?.copyrightIconSize
                            : 'lg',
                        }}
                        isGradientActive={isGradientActive}
                      />
                    </LazyImage>
                  )}
                </div>
                {checkValue(imgCaption) && checkValue(this.state.loadedClass) && (
                  <div className="image-caption">
                    {this.props.isGallery && (
                      <img className="loc-icon" src={onImageLoadWithoutCache("https://mesocp3.azureedge.net/media/8d82e09bea920f3/loc-icon.svg")} />
                    )}
                    {imgCaption}
                  </div>
                )}
              </div>
            </Layout>
          );
        }
      }
    };

    return <> {getHTML()}</>;
  }
}
